import { Model } from 'json-api-models';

import { Models, Product, Schemas } from '../models.ts';

export class Question extends Model<Schemas['questions'], Models> {
    shareUrl(product: Product): string {
        return import.meta.env.VITE_BASE_URL + `/${product.slug}/question/${this.item?.id}`;
    }

    get proportionCorrectColor(): string {
        if (this.attemptCount < 20) {
            return 'var(--color-muted)';
        }

        const proportionCorrect = this.proportionCorrect;

        if (proportionCorrect <= 0.15) {
            return 'var(--color-danger)';
        } else if (proportionCorrect <= 0.3) {
            return 'var(--color-warning)';
        } else if (proportionCorrect <= 0.4) {
            return 'var(--color-okay)';
        } else if (proportionCorrect <= 0.6) {
            return 'var(--color-success)';
        } else if (proportionCorrect <= 0.7) {
            return 'var(--color-okay)';
        } else if (proportionCorrect <= 0.85) {
            return 'var(--color-warning)';
        } else {
            return 'var(--color-danger)';
        }
    }

    get discriminationIndexColor(): string {
        if (this.discriminationIndex === null) {
            return 'var(--color-muted)';
        } else if (this.discriminationIndex <= -0.2) {
            return 'var(--color-danger)';
        } else if (this.discriminationIndex <= 0.2) {
            return 'var(--color-warning)';
        } else if (this.discriminationIndex <= 0.4) {
            return 'var(--color-okay)';
        } else {
            return 'var(--color-success)';
        }
    }
}
